import { Slug } from "@/sanity/sanity.types";
import { type FilmomtaleDocument, type NewsDocument } from "@/sanity/types/DeRefImageField";
import { FilmwebNews } from "@/sanity/types/filmwebSanityTypes";

export default function getDocumentUrl(document: FilmomtaleDocument | NewsDocument | FilmwebNews) {
    switch (document._type) {
        case "bygdekinoenFilmomtale":
            return `/film/${document.edi?.current}`;
        case "bygdekinoenNewsDocument":
            return `/artikkel/${document.slug?.current}`;
        case "filmnytt":
            return `https://www.filmweb.no/${document.isStreaming ? "streamingguide/artikkel" : "filmnytt"}/${document.slug.current}`


    }
}

export function getDocumentUrlBySlug(docType: "bygdekinoenFilmomtale" | "bygdekinoenNewsDocument", slug: Slug) {
    switch (docType) {
        case "bygdekinoenFilmomtale":
            return `/film/${slug.current}`;
        case "bygdekinoenNewsDocument":
            return `/artikkel/${slug.current}`;
    }
}